<!-- src/components/X62.vue -->
<template>
  <div :class="['x6', { 'x6--header': variant === 'header' }]">
    <img
      class="image-25"
      src="@/assets/cdn-animaapp/logo.svg"
      alt="Логотип академии"
    />
  </div>
</template>

<script>
export default {
  name: "X62",
  props: {
    variant: {
      type: String,
      default: 'default',
      validator: value => ['default', 'header'].includes(value)
    }
  }
};
</script>

<style>
/* Оригинальные стили для обратной совместимости */
.x6,
.x6-1,
.x6-2,
.x6-3,
.x6-4,
.x6-5,
.x6-6,
.x6-7,
.x6-8,
.x6-9,
.x6-10,
.x6-11,
.x6-12,
.x6-13,
.x6-14 {
  aspect-ratio: 1.81;
  height: 53.64px;
  position: relative;
  width: 99px;
}

.text-375,
.text-567,
.text-660,
.text-774,
.text-957,
.text-1035,
.text-1098,
.text-1320,
.text-1429,
.text-1612,
.text-1649,
.text-1701,
.text-1735,
.text-1918,
.text-2110 {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-items: flex-end;
  display: -webkit-box;
  height: 9px;
  justify-content: center;
  left: 47px;
  letter-spacing: 0;
  line-height: normal;
  overflow: hidden;
  position: absolute;
  text-overflow: ellipsis;
  top: 45px;
  width: 48px;
}

.image-25,
.image-26,
.image-27,
.image-28,
.image-29,
.image-30,
.image-31,
.image-32,
.image-33,
.image-34,
.image-35,
.image-36,
.image-37,
.image-38,
.image-39 {
  aspect-ratio: 2.03;
  height: 48px;
  left: 0;
  position: absolute;
  top: 0;
  width: 97px;
}

/* Новые стили для header варианта */
.x6--header {
  position: relative !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.x6--header:hover {
  transform: scale(1.05);
}

.x6--header .text-375 {
  z-index: 2;
}

.x6--header .image-25 {
  z-index: 1;
}

/* Utility класс */
.prostoone-normal-thunder-7px {
  color: #636363;
  font-family: "Prosto One", cursive;
  font-size: 7px;
  font-weight: 400;
}
</style>